<template>
  <el-dialog title="打印预览" :visible.sync="show" fullscreen :before-close="handleClose">
    <div>
      <span style="display: flex; margin-bottom: 20px;" class="dialog-footer">
        <div style="flex: 1;" />
        <el-button type="primary" @click="print">打印</el-button>
        <el-button @click="show=false">取消</el-button>
      </span>
    </div>

    <!-- 打印内容区域 -->
    <div id="printId">
      <!-- 报告标题 -->
      <div style="display: flex; justify-content: center; align-items: center; font-size: 24px; margin-bottom: 20px; margin-top: 20px;">
        体质检测分析报告
      </div>

      <!-- 基本信息表格 -->
      <div style="display: flex; justify-content: center; align-items: center;">
        <div>
          <div style="display: flex;">
            <div class="formItem">昵称</div>
            <div class="formItemwhite">{{ printData.userName }}</div>
            <div class="formItem">性别</div>
            <div class="formItemwhite">{{ printData.sexSign == 1 ? '男' : '女' }}</div>
          </div>
          <div style="display: flex;">
            <div class="formItem">年龄</div>
            <div class="formItemwhite">{{ printData.age }}</div>
            <div class="formItem">出生日期</div>
            <div class="formItemwhite">{{ printData.birthDate }}</div>
          </div>
          <div style="display: flex;">
            <div class="formItem">检测日期</div>
            <div class="formItemwhite">{{ printData.diagTime }}</div>
            <div class="formItem">检测门店</div>
            <div class="formItemwhite">{{ printData.storeName }}</div>
          </div>
          <div style="display: flex;">
            <div class="formItem">门店地址</div>
            <div class="formItemwhite">{{ printData.contactAddress }}</div>
            <div class="formItem">联系电话</div>
            <div class="formItemwhite">{{ printData.contactPhone }}</div>
          </div>
        </div>
      </div>

      <!-- 体质部分标题 -->
      <div style="margin: 30px 0 10px 0; font-size: 18px; font-weight: bold; display: flex;">
        <div style="border-left: 5px solid rgb(22, 93, 255); padding:0 0 10px 10px; margin-left: 10px;" />
        体质
      </div>

      <!-- 体质模块 -->
      <div style="padding: 10px;">
        <div v-if="subPhyCount === 0">
          <div class="main-phy-large" style="display: flex; align-items: center; justify-content: center; padding: 20px; background: linear-gradient(135deg, #f8f9ff 0%, #e8f0ff 100%); border-radius: 12px; margin: 20px auto; max-width: 600px;">
            <div style="display: flex; align-items: center; width: 100%;">
              <div style="margin-right: 20px;">
                <img v-if="printData.mainPhyCode" :src="require(`@/assets/health/${printData.mainPhyCode}.png`)" alt="" style="width: 80px; height: 80px;">
              </div>
              <div style="flex: 1;">
                <div style="font-size: 20px; font-weight: bold; color: #165dff; margin-bottom: 8px;">
                  {{ printData.mainPhyName }}
                </div>
                <div style="font-size: 16px; color: #666;">
                  程度：<span style="font-weight: bold; color: #165dff;">{{ printData.mainPhyPct }}%</span>
                </div>
              </div>
              <div>
                <img src="@/assets/icon/zhutizhi.png" alt="" style="width: 60px; height: 60px;">
              </div>
            </div>
          </div>
        </div>

        <div v-else-if="subPhyCount === 1">
          <div style="display: flex; justify-content: space-between; align-items: stretch; margin: 20px auto; max-width: 800px;">
            <div class="main-phy-large" style="flex: 2; margin-right: 15px; padding: 25px; background: linear-gradient(135deg, #f8f9ff 0%, #e8f0ff 100%); border-radius: 12px; display: flex; align-items: center;">
              <div style="margin-right: 20px;">
                <img v-if="printData.mainPhyCode" :src="require(`@/assets/health/${printData.mainPhyCode}.png`)" alt="" style="width: 80px; height: 80px;">
              </div>
              <div style="flex: 1;">
                <div style="font-size: 22px; font-weight: bold; color: #165dff; margin-bottom: 8px;">
                  {{ printData.mainPhyName }}
                </div>
                <div style="font-size: 18px; color: #666;">
                  程度：<span style="font-weight: bold; color: #165dff;">{{ printData.mainPhyPct }}%</span>
                </div>
              </div>
              <div>
                <img src="@/assets/icon/zhutizhi.png" alt="" style="width: 60px; height: 60px;">
              </div>
            </div>

            <div v-for="item in getSubPhyList()" :key="item.index" class="sub-phy-item" style="flex: 1; padding: 20px; background: #f9fafc; border-radius: 10px; border: 1px solid #e5e7eb; display: flex; align-items: center; margin-left: 15px;">
              <div style="margin-right: 15px;">
                <img :src="require(`@/assets/health/${item.code}.png`)" alt="" style="width: 50px; height: 50px;">
              </div>
              <div style="flex: 1;">
                <div style="font-size: 16px; font-weight: 600; color: #333; margin-bottom: 5px;">
                  {{ item.name }}
                </div>
                <div style="font-size: 14px; color: #666;">
                  程度：{{ item.pct }}%
                </div>
              </div>
              <div>
                <img src="@/assets/icon/futizhi.png" alt="" style="width: 40px; height: 40px;">
              </div>
            </div>
          </div>
        </div>

        <div v-else>
          <div class="main-phy-large" style="padding: 25px; background: linear-gradient(135deg, #f8f9ff 0%, #e8f0ff 100%); border-radius: 12px; margin: 20px auto; max-width: 700px; display: flex; align-items: center;">
            <div style="margin-right: 20px;">
              <img v-if="printData.mainPhyCode" :src="require(`@/assets/health/${printData.mainPhyCode}.png`)" alt="" style="width: 80px; height: 80px;">
            </div>
            <div style="flex: 1;">
              <div style="font-size: 22px; font-weight: bold; color: #165dff; margin-bottom: 8px;">
                {{ printData.mainPhyName }}
              </div>
              <div style="font-size: 18px; color: #666;">
                程度：<span style="font-weight: bold; color: #165dff;">{{ printData.mainPhyPct }}%</span>
              </div>
            </div>
            <div>
              <img src="@/assets/icon/zhutizhi.png" alt="" style="width: 60px; height: 60px;">
            </div>
          </div>

          <div style="display: flex; flex-wrap: wrap; justify-content: center; margin-top: 30px;">
            <div v-for="item in getSubPhyList()" :key="item.index" class="sub-phy-item" style="width: 280px; margin: 10px; padding: 15px; background: #f9fafc; border-radius: 10px; border: 1px solid #e5e7eb; display: flex; align-items: center;">
              <div style="margin-right: 15px;">
                <img :src="require(`@/assets/health/${item.code}.png`)" alt="" style="width: 50px; height: 50px;">
              </div>
              <div style="flex: 1;">
                <div style="font-size: 16px; font-weight: 600; color: #333; margin-bottom: 5px;">
                  {{ item.name }}
                </div>
                <div style="font-size: 14px; color: #666;">
                  程度：{{ item.pct }}%
                </div>
              </div>
              <div>
                <img src="@/assets/icon/futizhi.png" alt="" style="width: 40px; height: 40px;">
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 面诊部分（加 section-block 包裹） -->
      <div class="section-block">
        <!-- 面诊部分标题 -->
        <div style="margin: 30px 0 10px 0; font-size: 18px; font-weight: bold; display: flex;">
          <div style="border-left: 5px solid rgb(22, 93, 255); padding:0 0 10px 10px; margin-left: 10px;" />
          面诊
        </div>
        <!-- 面诊图片 -->
        <div style="text-align: center; margin: 10px 0; ">
          <img style="height: 200px;" :src="getsrc(printData.faceImg)" alt="">
        </div>
        <!-- 面诊表格 -->
        <div style="display: flex; justify-content: center; align-items: center;">
          <div>
            <div style="display: flex;">
              <div class="formItem">指标</div>
              <div class="formItem" style="width: 300px;">说明</div>
            </div>
            <div style="display: flex;">
              <div class="formItemwhite">面部颜色</div>
              <div class="formItemwhite" style="width: 300px; background: #fff;">
                {{ getOptions('faceColorSign', printData.faceColorSign) }}
              </div>
            </div>
            <div style="display: flex;">
              <div class="formItemwhite">面部色泽</div>
              <div class="formItemwhite" style="width: 300px; background: #fff;">
                {{ getOptions('faceLustreSign', printData.faceLustreSign) }}
              </div>
            </div>
            <div style="display: flex;">
              <div class="formItemwhite">嘴唇检测</div>
              <div class="formItemwhite" style="width: 300px; background: #fff;">
                {{ getOptions('lipRecognitionSign', printData.lipRecognitionSign) }}
              </div>
            </div>
            <div style="display: flex;">
              <div class="formItemwhite">嘴唇</div>
              <div class="formItemwhite" style="width: 300px; background: #fff;">
                {{ getOptions('lipColorSign', printData.lipColorSign) }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 舌诊部分（加 section-block 包裹） -->
      <div class="section-block">
        <!-- 舌诊部分标题 -->
        <div style="margin: 30px 0 10px 0; font-size: 18px; font-weight: bold; display: flex;">
          <div style="border-left: 5px solid rgb(22, 93, 255); padding:0 0 10px 10px; margin-left: 10px;" />
          舌诊
        </div>
        <!-- 舌诊图片 -->
        <div style="text-align: center; margin: 10px 0;">
          <img style="height: 200px;" :src="getsrc(printData.tongueImg)" alt="">
        </div>
        <!-- 舌诊表格 -->
        <div style="display: flex; justify-content: center; align-items: center;">
          <div>
            <div style="display: flex;">
              <div class="formItem">指标</div>
              <div class="formItem" style="width: 300px;">说明</div>
            </div>
            <div style="display: flex;">
              <div class="formItemwhite">舌裂纹检测</div>
              <div class="formItemwhite" style="width: 300px; background: #fff;">
                {{ getOptions('tongueCrackSign', printData.tongueCrackSign) }}
              </div>
            </div>
            <div style="display: flex;">
              <div class="formItemwhite">舌胖瘦检测</div>
              <div class="formItemwhite" style="width: 300px; background: #fff;">
                {{ getOptions('tongueFatSign', printData.tongueFatSign) }}
              </div>
            </div>
            <div style="display: flex;">
              <div class="formItemwhite">舌苔厚薄检测</div>
              <div class="formItemwhite" style="width: 300px; background: #fff;">
                {{ getOptions('tongueCoatThickSign', printData.tongueCoatThickSign) }}
              </div>
            </div>
            <div style="display: flex;">
              <div class="formItemwhite">舌苔颜色检测</div>
              <div class="formItemwhite" style="width: 300px; background: #fff;">
                {{ getOptions('tongueCoatColorSign', printData.tongueCoatColorSign) }}
              </div>
            </div>
            <div style="display: flex;">
              <div class="formItemwhite">舌质颜色检测</div>
              <div class="formItemwhite" style="width: 300px; background: #fff;">
                {{ getOptions('tongueColorSign', printData.tongueColorSign) }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 方案部分标题 -->
      <div style="margin: 30px 0 10px 0; font-size: 18px; font-weight: bold; display: flex;">
        <div style="border-left: 5px solid rgb(22, 93, 255); padding:0 0 10px 10px; margin-left: 10px;" />
        方案
      </div>

      <!-- 方案内容：预览时用 iframe，打印时会提取内联 -->
      <div v-if="schemeHtml.head.htmlContentUrl" style="width: 100%; margin: 0 auto; text-align: center;">
        <iframe
          :src="'/'+schemeHtml.head.htmlContentUrl"
          frameborder="0"
          scrolling="no"
          style="width: 100%; border: none; display: block; margin: 0 auto;"
          @load="onIframeLoad"
        />
      </div>
      <div v-else style="text-align: start; padding: 0 20px;" v-html="schemeHtml.head ? schemeHtml.head.htmlContent : ''" />

      <!-- 二维码 -->
      <div style="display: flex; justify-content: center;align-items: center; width: 100%; margin-top: 30px;">
        <div style="display: flex; flex-direction: column;justify-content: center;align-items: center; padding: 20px; border: 1px solid #eee; border-radius: 8px;">
          <img src="@/assets/health/qr.jpg" style="width: 120px; height: 120px; object-fit: contain;">
          <div style="margin-top: 10px; font-size: 14px; color: #666;">
            扫码在手机上查看报告
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { getSrc } from '@/utils/ik/oss/oss.js'

export default {
  props: {
    printData: {
      type: Object,
      default: () => ({})
    },
    schemeList: {
      type: Array,
      default: () => []
    },
    schemeHtml: {
      type: Object,
      default: () => ({})
    }
  },

  data() {
    return {
      show: false,
      columns: [
        { code: "code", name: "编码", span: 6, type: "text", config: { edit: false }},
        { code: "name", name: "名称", span: 6, type: "text", config: { edit: false }},
        { code: "userCode", name: "用户编码", span: 6, type: "text", config: { edit: false }},
        { code: "userName", name: "用户名称", span: 6, type: "text", config: { edit: false }},
        { code: "robotCode", name: "机器人编码", span: 6, type: "text", config: { edit: false }},
        { code: "robotName", name: "机器人名称", span: 6, type: "text", config: { edit: false }},
        { code: "stateSign", name: "报告状态标识", type: "select", span: 6, config: { edit: false, keyField: "key", valueField: "value", options: [{ key: "1", value: "未出报告" }, { key: "2", value: "已出报告" }] }},
        { code: "diagTime", name: "诊断时间", type: "datetime", span: 6, config: { edit: false }},
        { code: "mainPhyCode", name: "主体质编码", type: "text", span: 6, config: { edit: false }},
        { code: "mainPhyName", name: "主体质名称", type: "text", span: 6, config: { edit: false }},
        { code: "mainPhyPct", name: "主体质程度", type: "number", span: 6, config: { edit: false }},
        { code: "phy1Code", name: "副体质1编码", type: "text", span: 6, config: { edit: false }},
        { code: "phy1Name", name: "副体质1名称", type: "text", span: 6, config: { edit: false }},
        { code: "phyPct1", name: "副体质1程度", type: "number", span: 6, config: { edit: false }},
        { code: "phy2Code", name: "副体质2编码", type: "text", span: 6, config: { edit: false }},
        { code: "phy2Name", name: "副体质2名称", type: "text", span: 6, config: { edit: false }},
        { code: "phyPct2", name: "副体质2程度", type: "number", span: 6, config: { edit: false }},
        { code: "phy3Code", name: "副体质3编码", type: "text", span: 6, config: { edit: false }},
        { code: "phy3Name", name: "副体质3名称", type: "text", span: 6, config: { edit: false }},
        { code: "phyPct3", name: "副体质3程度", type: "number", span: 6, config: { edit: false }},
        { code: "phy4Code", name: "副体质4编码", type: "text", span: 6, config: { edit: false }},
        { code: "phy4Name", name: "副体质4名称", type: "text", span: 6, config: { edit: false }},
        { code: "phyPct4", name: "副体质4程度", type: "number", span: 6, config: { edit: false }},
        { code: "phy5Code", name: "副体质5编码", type: "text", span: 6, config: { edit: false }},
        { code: "phy5Name", name: "副体质5名称", type: "text", span: 6, config: { edit: false }},
        { code: "phyPct5", name: "副体质5程度", type: "number", span: 6, config: { edit: false }},
        { code: "phy6Code", name: "副体质6编码", type: "text", span: 6, config: { edit: false }},
        { code: "phy6Name", name: "副体质6名称", type: "text", span: 6, config: { edit: false }},
        { code: "phyPct6", name: "副体质6程度", type: "number", span: 6, config: { edit: false }},
        { code: "phy7Code", name: "副体质7编码", type: "text", span: 6, config: { edit: false }},
        { code: "phy7Name", name: "副体质7名称", type: "text", span: 6, config: { edit: false }},
        { code: "phyPct7", name: "副体质7程度", type: "number", span: 6, config: { edit: false }},
        { code: "phy8Code", name: "副体质8编码", type: "text", span: 6, config: { edit: false }},
        { code: "phy8Name", name: "副体质8名称", type: "text", span: 6, config: { edit: false }},
        { code: "phyPct8", name: "副体质8程度", type: "number", span: 6, config: { edit: false }},
        { code: "phyDiagSign", name: "体质诊断标注标识", type: "select", span: 6, config: { edit: false, keyField: "key", valueField: "value", options: [{ key: "0", value: "未标注" }, { key: "1", value: "已标注" }] }},
        { code: "faceImg", name: "诊断健康指数", type: "oss", span: 6, config: { edit: false }},
        { code: "faceRecognitionSign", name: "面部检测结果", type: "select", span: 6, config: { edit: false, keyField: "key", valueField: "value", options: [{ key: "0", value: "未测出人脸" }, { key: "1", value: "测出人脸" }] }},
        { code: "faceColorSign", name: "面部颜色结果", type: "select", span: 6, config: { edit: false, keyField: "key", valueField: "value", options: [{ key: "0", value: "面白" }, { key: "1", value: "面黑" }, { key: "2", value: "面红" }, { key: "3", value: "面黄" }, { key: "4", value: "面青" }, { key: "5", value: "正常" }] }},
        { code: "faceLustreSign", name: "面部色泽结果", type: "select", span: 6, config: { edit: false, keyField: "key", valueField: "value", options: [{ key: "0", value: "有光泽" }, { key: "1", value: "少光泽" }, { key: "2", value: "无光泽" }] }},
        { code: "lipRecognitionSign", name: "嘴唇检测结果", type: "select", span: 6, config: { edit: false, keyField: "key", valueField: "value", options: [{ key: "0", value: "未测出嘴唇" }, { key: "1", value: "测出嘴唇" }] }},
        { code: "lipColorSign", name: "嘴唇颜色结果", type: "select", span: 6, config: { edit: false, keyField: "key", valueField: "value", options: [{ key: "0", value: "淡白" }, { key: "1", value: "淡红" }, { key: "2", value: "红" }, { key: "3", value: "暗红" }, { key: "4", value: "紫" }] }},
        { code: "faceDiagSign", name: "面诊诊断标注标识", type: "select", span: 6, config: { edit: false, keyField: "key", valueField: "value", options: [{ key: "0", value: "未标注" }, { key: "1", value: "已标注" }] }},
        { code: "diagFaceColorSign", name: "诊断面部颜色结果", type: "select", span: 6, config: { edit: false, keyField: "key", valueField: "value", options: [{ key: "0", value: "面白" }, { key: "1", value: "面黑" }, { key: "2", value: "面红" }, { key: "3", value: "面黄" }, { key: "4", value: "面青" }, { key: "5", value: "正常" }] }},
        { code: "diagFaceLustreSign", name: "诊断面部色泽结果", type: "select", span: 6, config: { edit: false, keyField: "key", valueField: "value", options: [{ key: "0", value: "有光泽" }, { key: "1", value: "少光泽" }, { key: "2", value: "无光泽" }] }},
        { code: "diagLipColorSign", name: "诊断嘴唇颜色结果", type: "select", span: 6, config: { edit: false, keyField: "key", valueField: "value", options: [{ key: "0", value: "淡白" }, { key: "1", value: "淡红" }, { key: "2", value: "红" }, { key: "3", value: "暗红" }, { key: "4", value: "紫" }] }},
        { code: "tongueImg", name: "舌诊图像", type: "oss", span: 6, config: { edit: false }},
        { code: "tongueRecognitionSign", name: "舌体检测结果", type: "select", span: 6, config: { edit: false, keyField: "key", valueField: "value", options: [{ key: "0", value: "未测出舌象" }, { key: "1", value: "测出舌象" }] }},
        { code: "tongueCrackSign", name: "舌裂纹检测结果", type: "select", span: 6, config: { edit: false, keyField: "key", valueField: "value", options: [{ key: "0", value: "未检测到舌裂纹" }, { key: "1", value: "检测到舌裂纹" }] }},
        { code: "tongueFatSign", name: "舌胖瘦检测结果", type: "select", span: 6, config: { edit: false, keyField: "key", valueField: "value", options: [{ key: "0", value: "正常" }, { key: "1", value: "胖舌" }] }},
        { code: "tongueCoatThickSign", name: "舌苔厚薄检测结果", type: "select", span: 6, config: { edit: false, keyField: "key", valueField: "value", options: [{ key: "0", value: "薄" }, { key: "1", value: "厚" }] }},
        { code: "tongueCoatColorSign", name: "舌苔颜色检测结果", type: "select", span: 6, config: { edit: false, keyField: "key", valueField: "value", options: [{ key: "0", value: "苔白" }, { key: "1", value: "苔黄" }] }},
        { code: "tongueColorSign", name: "舌质颜色检测结果", type: "select", span: 6, config: { edit: false, keyField: "key", valueField: "value", options: [{ key: "0", value: "舌暗红" }, { key: "1", value: "舌淡白" }, { key: "2", value: "舌淡红" }, { key: "3", value: "舌红" }, { key: "4", value: "舌深红(舌紫)" }] }},
        { code: "tongueDiagSign", name: "舌诊诊断标注标识", type: "select", span: 6, config: { edit: false, keyField: "key", valueField: "value", options: [{ key: "0", value: "未标注" }, { key: "1", value: "已标注" }] }},
        { code: "diagTongueCrackSign", name: "诊断舌裂纹检测结果", type: "select", span: 6, config: { edit: false, keyField: "key", valueField: "value", options: [{ key: "0", value: "未检测到舌裂纹" }, { key: "1", value: "检测到舌裂纹" }] }},
        { code: "diagTongueFatSign", name: "诊断舌胖瘦检测结果", type: "select", span: 6, config: { edit: false, keyField: "key", valueField: "value", options: [{ key: "0", value: "正常" }, { key: "1", value: "胖舌" }] }},
        { code: "diagTongueCoatThickSign", name: "诊断舌苔厚薄检测结果", type: "select", span: 6, config: { edit: false, keyField: "key", valueField: "value", options: [{ key: "0", value: "薄" }, { key: "1", value: "厚" }] }},
        { code: "diagTongueCoatColorSign", name: "诊断舌苔颜色检测结果", type: "select", span: 6, config: { edit: false, keyField: "key", valueField: "value", options: [{ key: "0", value: "苔白" }, { key: "1", value: "苔黄" }] }},
        { code: "diagTongueColorSign", name: "诊断舌质颜色检测结果", type: "select", span: 6, config: { edit: false, keyField: "key", valueField: "value", options: [{ key: "1", value: "舌暗红" }, { key: "2", value: "舌淡白" }, { key: "2", value: "舌淡红" }, { key: "2", value: "舌红" }, { key: "2", value: "舌深红(舌紫)" }] }}
      ]
    }
  },

  computed: {
    subPhyCount() {
      let count = 0
      for (let i = 1; i <= 8; i++) {
        if (this.printData['phy' + i + 'Name']) count++
      }
      return count
    }
  },

  methods: {
    getSubPhyList() {
      const list = []
      for (let i = 1; i <= 8; i++) {
        if (this.printData['phy' + i + 'Name']) {
          list.push({
            index: i,
            code: this.printData['phy' + i + 'Code'],
            name: this.printData['phy' + i + 'Name'],
            pct: this.printData['phyPct' + i]
          })
        }
      }
      return list
    },

    handleClose() {
      this.show = false
    },

    getsrc(url) {
      if (url) return getSrc('', url)
    },

    handleOpen() {
      this.show = true
    },

    getQRCodeSrc() {
      if (this.printData.qrCodeUrl) return this.getsrc(this.printData.qrCodeUrl)
      const defaultQR = require('@/assets/health/qr.jpg')
      if (process.env.NODE_ENV === 'production') {
        const baseUrl = window.location.origin
        const publicPath = process.env.VUE_APP_PUBLIC_PATH || '/'
        if (defaultQR && defaultQR.default) {
          return baseUrl + publicPath + defaultQR.default.replace(/^.*[\\\/]/, '')
        } else if (typeof defaultQR === 'string') {
          return defaultQR.startsWith('http') ? defaultQR : baseUrl + publicPath + defaultQR.replace(/^.*[\\\/]/, '')
        }
      }
      return defaultQR
    },

    /** iframe 预览时自适应高度 */
    onIframeLoad(e) {
      const iframe = e.target
      try {
        const doc = iframe.contentDocument || iframe.contentWindow.document
        const updateHeight = () => {
          const h = doc.documentElement.scrollHeight || doc.body.scrollHeight
          if (h > 0) iframe.style.height = h + 'px'
        }
        updateHeight()
        const ro = new ResizeObserver(() => updateHeight())
        ro.observe(doc.body)
        setTimeout(updateHeight, 1000)
      } catch (err) {
        iframe.style.height = '1850px'
      }
    },

    /** 打印入口 */
    async print() {
      try {
        const source = document.getElementById('printId')
        if (!source) {
          this.$message.error('未找到打印内容')
          return
        }

        // 1. 等待当前页图片加载完成
        const sourceImgs = Array.from(source.querySelectorAll('img'))
        await Promise.all(
          sourceImgs.map(img =>
            img.complete
              ? Promise.resolve()
              : new Promise(r => { img.onload = r; img.onerror = r })
          )
        )

        // 2. 克隆 DOM
        const clone = source.cloneNode(true)

        // 3. 修正图片为绝对路径
        const cloneImgs = clone.querySelectorAll('img')
        cloneImgs.forEach((img, i) => {
          const orig = sourceImgs[i]
          img.src = orig.currentSrc || orig.src
          img.style.display = 'block'
          img.style.maxWidth = '100%'
        })

        // 4. 处理 iframe：优先提取内容内联，避免 iframe 打印边界问题
        let schemeHtmlContent = ''
        let schemeHtmlStyles = ''
        const iframe = source.querySelector('iframe')
        if (iframe) {
          try {
            // 尝试同域读取
            const idoc = iframe.contentDocument || iframe.contentWindow.document
            schemeHtmlContent = idoc.body.innerHTML
            schemeHtmlStyles = Array.from(idoc.querySelectorAll('style, link[rel="stylesheet"]'))
              .map(t => t.outerHTML).join('')
          } catch (e) {
            // 跨域时尝试 fetch
            try {
              const resp = await fetch(iframe.src)
              const html = await resp.text()
              const bodyMatch = html.match(/<<body[^>]*>([\s\S]*?)<<\/body>/i)
              schemeHtmlContent = bodyMatch ? bodyMatch[1] : html
              const headMatch = html.match(/<<head[^>]*>([\s\S]*?)<<\/head>/i)
              if (headMatch) {
                const headHtml = headMatch[1]
                const styles = (headHtml.match(/<<style[^>]*>[\s\S]*?<\/style>/gi) || [])
                const links = (headHtml.match(/<<link[^>]*>/gi) || [])
                schemeHtmlStyles = [...styles, ...links].join('')
              }
            } catch (fetchErr) {
              console.warn('fetch iframe failed:', fetchErr)
            }
          }
        }

        // 如果有提取到内容，替换克隆节点中的 iframe
        if (schemeHtmlContent) {
          const cloneIframe = clone.querySelector('iframe')
          if (cloneIframe) {
            const wrapper = document.createElement('div')
            wrapper.className = 'scheme-print-wrapper'
            wrapper.innerHTML = schemeHtmlStyles + schemeHtmlContent
            cloneIframe.parentNode.replaceChild(wrapper, cloneIframe)
          }
        }

        // 5. 收集当前页样式
        const pageStyles = Array.from(document.querySelectorAll('style, link[rel="stylesheet"]'))
          .map(tag => tag.outerHTML)
          .join('')

        // 6. 组装打印页
        const userName = this.printData.userName || ''
        const time = this.printData.entryTime || this.printData.diagTime || ''
        const code = this.printData.code || ''

        const printHTML = `
<!DOCTYPE html>
<html>
<head>
<meta charset="UTF-8">
<title>体质检测报告 - ${userName}</title>
${pageStyles}
<style>
  @page { size: A4; margin: 12mm; }
  body {
    margin: 0; padding: 0;
    font-family: "Microsoft YaHei", Arial, sans-serif;
    font-size: 12pt; color: #333;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
  .print-header {
    border-bottom: 1px solid #666;
    padding-bottom: 8px;
    margin-bottom: 15px;
    page-break-after: avoid;
  }
  .print-header-row {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
  }
  .print-header-name { font-size: 18pt; font-weight: bold; }
  .print-header-time { font-size: 12pt; color: #666; }
  .print-header-code { text-align: right; font-size: 12pt; margin-top: 4px; }
  .print-header-note { text-align: right; color: #666; font-size: 10pt; margin-top: 2px; }

  /* 补全关键 class 样式 */
  .formItem {
    width: 150px; background: #F2F3F5;
    border: 1px solid rgb(229, 230, 235); height: 40px;
    display: flex; align-items: center; padding-left: 10px;
    box-sizing: border-box;
  }
  .formItemwhite {
    width: 150px; border: 1px solid #E5E6EB;
    height: 40px; display: flex; align-items: center;
    padding-left: 10px; background: #FFFFFF;
    box-sizing: border-box;
  }
  .main-phy-large {
    box-shadow: 0 4px 12px rgba(22, 93, 255, 0.1);
    position: relative; overflow: hidden;
  }
  .main-phy-large::before {
    content: ''; position: absolute; top: 0; left: 0;
    width: 5px; height: 100%;
    background: linear-gradient(to bottom, #165dff, #8bb5ff);
  }
  .sub-phy-item { box-shadow: 0 2px 8px rgba(0,0,0,0.05); }

  /* 防止打印时分页截断关键块 */
  .main-phy-large, .sub-phy-item,
  .formItem, .formItemwhite {
    page-break-inside: avoid;
  }

  /* 面诊/舌诊等区块防截断（新增） */
  .section-block {
    break-inside: avoid !important;
    page-break-inside: avoid !important;
  }

  img { max-width: 100%; height: auto; display: block; margin: 0 auto; }

  /* ========== H5 方案内容打印适配（核心） ========== */
  .scheme-print-wrapper {
    width: 100%;
    margin: 0;
    padding: 0;
  }
  /* 强制覆盖移动端 375px 宽度限制 */
  .scheme-print-wrapper > div,
  .scheme-print-wrapper [style*="width:375px"],
  .scheme-print-wrapper [style*="width: 375px"] {
    width: 100% !important;
    min-width: 100% !important;
    max-width: 100% !important;
    display: block !important;
  }
  /* 移除移动端固定高度、阴影、圆角 */
  .scheme-print-wrapper [style*="min-height:812px"],
  .scheme-print-wrapper [style*="min-height: 812px"] {
    min-height: auto !important;
    height: auto !important;
  }
  .scheme-print-wrapper [style*="box-shadow:0 20px 60px"],
  .scheme-print-wrapper [style*="box-shadow: 0 20px 60px"] {
    box-shadow: none !important;
  }
  .scheme-print-wrapper [style*="border-radius:24px"],
  .scheme-print-wrapper [style*="border-radius: 24px"] {
    border-radius: 0 !important;
  }
  /* 右侧内容区解除 flex */
  .scheme-print-wrapper [style*="flex-direction:column"],
  .scheme-print-wrapper [style*="flex-direction: column"] {
    display: block !important;
    overflow: visible !important;
  }
  /* 每个卡片三层防截断 */
  .scheme-print-wrapper .section-card,
  .scheme-print-wrapper div[style*="margin:12px 14px"],
  .scheme-print-wrapper div[style*="margin: 12px 14px"],
  .scheme-print-wrapper div[style*="margin:6px 14px"],
  .scheme-print-wrapper div[style*="margin: 6px 14px"] {
    margin: 6px 0 !important;
    break-inside: avoid !important;
    page-break-inside: avoid !important;
  }
  .scheme-print-wrapper .section-card > div,
  .scheme-print-wrapper div[style*="background:rgba(255,255,255"],
  .scheme-print-wrapper div[style*="background:linear-gradient(135deg,#4F9E76"] {
    break-inside: avoid !important;
    page-break-inside: avoid !important;
  }
  .scheme-print-wrapper .section-card > div > div {
    break-inside: avoid !important;
    page-break-inside: avoid !important;
  }
  /* 标题行后不要分页 */
  .scheme-print-wrapper .section-card > div > div:first-child {
    break-after: avoid !important;
    page-break-after: avoid !important;
  }
  /* 隐藏底部占位 */
  .scheme-print-wrapper [style*="height:28px"] {
    display: none !important;
  }

  @media print {
    body { background: white; }
    .scheme-print-wrapper { background: white; }
  }
  @media screen {
    body { background: #f0f2f5; padding: 20px; }
    .print-wrapper {
      max-width: 800px; margin: 0 auto;
      background: white; padding: 20px;
      box-shadow: 0 2px 8px rgba(0,0,0,0.1);
    }
  }
</style>
</head>
<body>
  <div class="print-wrapper">
    <div class="print-header">
      <div class="print-header-row">
        <div class="print-header-name">${userName}</div>
        <div class="print-header-time">${time}</div>
      </div>
      <div class="print-header-code">编号: ${code}</div>
      <div class="print-header-note">检测结果仅供参考，不作为医疗诊断依据</div>
    </div>
    ${clone.innerHTML}
  </div>
</body>
</html>`

        // 7. 写入新窗口
        const win = window.open('', '_blank')
        win.document.open()
        win.document.write(printHTML)
        win.document.close()

        // 8. 触发打印（兜底 2 秒）
        setTimeout(() => {
          win.focus()
          win.print()
          setTimeout(() => win.close(), 500)
        }, 2000)
      } catch (error) {
        console.error('打印失败:', error)
        this.$message.error('打印失败，请重试')
      }
    },

    getOptions(code, key) {
      let text = ''
      this.columns.forEach(element => {
        if (element.code === code) {
          element.config.options.forEach(item => {
            if (key === item.key) text = item.value
          })
        }
      })
      return text
    }
  }
}
</script>

<style lang="scss" scoped>
/* 屏幕预览样式 */
#printId {
  background: white;
  padding: 20px;
}

/* 表单样式 */
.formItem {
  width: 150px;
  background: #F2F3F5;
  border: 1px solid rgb(229, 230, 235);
  height: 40px;
  display: flex;
  align-items: center;
  padding-left: 10px;
}

.formItemwhite {
  width: 150px;
  border: 1px solid #E5E6EB;
  height: 40px;
  display: flex;
  align-items: center;
  padding-left: 10px;
  background: #FFFFFF;
}

/* 体质模块样式 */
.main-phy-large {
  box-shadow: 0 4px 12px rgba(22, 93, 255, 0.1);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.main-phy-large::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 5px;
  height: 100%;
  background: linear-gradient(to bottom, #165dff, #8bb5ff);
}

.sub-phy-item {
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.sub-phy-item:hover {
  transform: translateY(-3px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

/* 打印样式 */
@media print {
  @page {
    margin: 15mm;
  }

  .formItem, .formItemwhite {
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
    background-color: #F2F3F5 !important;
    border: 1px solid #E5E6EB !important;
  }

  .formItemwhite {
    background-color: #FFFFFF !important;
  }

  #printId * {
    visibility: visible !important;
  }

  .el-dialog__header,
  .el-dialog__footer,
  .dialog-footer {
    display: none !important;
  }

  #printId {
    margin: 0 !important;
    padding: 0 !important;
    width: 100% !important;
    max-width: none !important;
    min-height: 100vh !important;
  }
}
</style>
